import { ConfigDef } from "../type/config-def";
import { TIME_GRAINS_COARSE_TO_FINE, TIME_GRAIN_LABELS } from "../time-grain";

export class ConfigAdapter {
  // req は asset_id（未指定可）。data_properties は asset_id 任意。
  static toInputDTO(req: any): any {
    return { asset_id: req };
  }

  static toOutputDTO(res: any): ConfigDef {
    // data_properties レスポンス（data_properties_list）を旧 column_properties 互換へ整形。
    // data_properties は unit 単一のため ja/en とも同値を使う。
    const dataProperties: any[] = res?.data_properties_list ?? [];
    const columnProperties = dataProperties.map((e: any) => ({
      value: e.value,
      name: e.name,
      name_en: e.name_en,
      unit: e.unit ?? "",
      unit_en: e.unit ?? "",
      // 階層色（グラフのノード表示）用。data_properties が唯一の layer マスタ。
      layer_no: e.layer_no ?? 0,
      type: null,
    }));

    const nodeAttrs = columnProperties.map((attr: any) => ({
      key: attr.value,
      meta: {
        type: attr.type || null,
        unit: { en: attr.unit_en, ja: attr.unit },
        label: { en: attr.name_en, ja: attr.name },
        options: null,
      },
    }));

    const subjectAttrs = [
      {
        key: "group",
        meta: {
          type: null,
          unit: null,
          label: { en: "Group", ja: "グループ" },
          options: null,
        },
      },
      {
        key: "age",
        meta: {
          type: null,
          unit: { en: "s", ja: "代" },
          label: { en: "Age", ja: "年代" },
          options: null,
          format: "*10",
        },
      },
      {
        key: "gender",
        meta: {
          type: null,
          unit: null,
          label: { en: "Gender", ja: "性別" },
          options: [
            { key: "0", label: { en: "Male", ja: "男性" }, color: "#2C69FF" },
            { key: "1", label: { en: "Female", ja: "女性" }, color: "#F68773" },
            {
              key: "9",
              label: { en: "Others", ja: "その他" },
              color: "#8897AA",
            },
          ],
        },
      },
    ];

    // 全粒度のラベルを渡す (実際に選べる粒度は querybar 側が time_granularities から決める)。
    // 3 つだけだと、分粒度などの vendor でラベルが引けず key がそのまま画面に出る。
    const timeGrain = TIME_GRAINS_COARSE_TO_FINE.map((key) => ({
      key,
      label: TIME_GRAIN_LABELS[key],
    }));

    return {
      node_attrs: nodeAttrs,
      subject_attrs: subjectAttrs,
      time_grain: timeGrain,
      // graph legacy の adaptQueryConfig は column_properties / symptom_* を参照するため互換形を渡す。
      // data_properties には symptom_body_name / symptom_name が無いので空配列。
      legacy: {
        column_properties: columnProperties,
        symptom_body_name: res?.symptom_body_name ?? [],
        symptom_name: res?.symptom_name ?? [],
      },
    };
  }
}
